import Grid from "@mui/material/Grid";
import React, { useEffect, useRef, useState } from "react";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import axios from "axios";

import Webcam from "react-webcam";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";

import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import MenuItem from "@mui/material/MenuItem";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InputAdornment from "@mui/material/InputAdornment";

import { Select } from "@mui/material";

function getContractList(useData) {
  if (Array.isArray(useData?.kontrak)) return useData.kontrak;
  if (Array.isArray(useData?.kontrakList)) return useData.kontrakList;
  if (useData?.kontrak) return [useData.kontrak];
  return [];
}

function getMainContract(useData) {
  return getContractList(useData)[0] || null;
}

function getCompanyName(useData) {
  const contract = getMainContract(useData);

  return (
    useData?.company?.namaPerusahaan ||
    useData?.company?.NamaPerusahaan ||
    contract?.CompanyName ||
    contract?.NamaPT ||
    ""
  );
}

function getClientName(useData) {
  const contract = getMainContract(useData);

  return (
    useData?.klien?.Nama ||
    useData?.klien?.nama ||
    contract?.KlienNama ||
    contract?.NamaKlien ||
    ""
  );
}

function getClientPhone(useData) {
  const phone = useData?.klien?.Phone;

  if (Array.isArray(phone)) return phone[0] || "";
  return phone || "";
}

function getMimeFromDataUrl(dataUrl) {
  const match = String(dataUrl || "").match(/^data:(.*?);/);
  return match?.[1] || "image/jpeg";
}

function dataURLtoBlob(dataUrl) {
  if (!dataUrl) return null;

  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1];

  if (!arr[1] || !mime) return null;

  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], { type: mime });
}

function getErrorMessage(error) {
  const serverData = error?.response?.data;

  if (typeof serverData === "string") return serverData;

  return (
    serverData?.message ||
    serverData?.error ||
    serverData?.details?.message ||
    error?.message ||
    "Gagal simpan surat / kirim WhatsApp."
  );
}

function buildUseDataPayload(useData) {
  const contract = getMainContract(useData);

  return {
    ...(useData || {}),

    /**
     * These IDs are the important part.
     * Your fixed backend should use these IDs to fetch fresh DB data.
     */
    companyId:
      useData?.companyId || useData?.company?._id || contract?.CompanyID || "",

    klienId: useData?.klienId || useData?.klien?._id || contract?.KlienID || "",

    kontrakId: useData?.kontrakId || contract?._id || "",

    /**
     * Keep full objects too for compatibility with your older backend.
     */
    company: useData?.company || null,
    klien: useData?.klien || null,
    kontrak: contract || null,
    kontrakList: getContractList(useData),
  };
}

export default function NewMailDialog({
  useData,
  searchThis,
  closeNewMail,
  onSaved,
}) {
  const initialContract = getMainContract(useData);

  const [openCamera, setOpenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [capturing, setCapturing] = useState(true);

  const webcamRef = useRef(null);

  const [nomorTandaTerima, setNomorTandaTerima] = useState("");
  const [pengirim, setPengirim] = useState("");

  const [selectedRooms, setSelectedRooms] = useState("Surat");
  const [selectedStorage, setSelectedStorage] = useState("Kotak Surat");

  const [storage] = useState([
    "Kotak Surat",
    "Ruangan Management",
    "Meja Resepsionis",
    "Lemari Resepsionis",
  ]);

  const [names] = useState([
    "Surat",
    "Paket Kecil",
    "Paket Besar",
    "Cairan",
    "Makanan",
    "Paket Sangat Besar",
  ]);

  const [notes, setNotes] = useState("");
  const [tanggalKejadian, setTanggalKejadian] = useState(new Date());
  const [lokasi, setLokasi] = useState(initialContract?.LokasiKontrak || "");

  const [categorias, setCategorias] = useState([]);

  const [saving, setSaving] = useState(false);
  const [progressText, setProgressText] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const companyName = getCompanyName(useData);
  const clientName = getClientName(useData);
  const clientPhone = getClientPhone(useData);
  const mainContract = getMainContract(useData);

  useEffect(() => {
    let active = true;

    const getCategorias = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/addressOptions`
        );

        if (!active) return;

        setCategorias(response.data?.pilihanAlamat || []);
      } catch (error) {
        console.error(error);

        if (!active) return;

        setError(
          error.response?.data?.message ||
            error.message ||
            "Gagal mengambil pilihan lokasi."
        );
      }
    };

    getCategorias();

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    const contract = getMainContract(useData);

    if (contract?.LokasiKontrak) {
      setLokasi((prev) => prev || contract.LokasiKontrak);
    }
  }, [useData]);

  const handleCapture = () => {
    const screenshot = webcamRef.current?.getScreenshot();

    if (!screenshot) {
      setError("Kamera gagal mengambil foto. Coba ulangi.");
      return;
    }

    setImageSrc(screenshot);
    setCapturing(false);
    setError("");
  };

  const handleRetake = () => {
    setCapturing(true);
    setImageSrc(null);
  };

  const handleUsePhoto = () => {
    setOpenCamera(false);
    setCapturing(true);
    setError("");
  };

  const handleOpenCamera = () => {
    setOpenCamera(true);
    setCapturing(true);
    setError("");
  };

  const handleCloseCamera = () => {
    setOpenCamera(false);
    setCapturing(true);
    setImageSrc(null);
  };

  const uploadPhotoAndGetKey = async (fotoBlob) => {
    const uploadUrlResponse = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getUploadURL`,
      {
        params: {
          filename: "fileFoto",
        },
      }
    );

    const uploadUrl = uploadUrlResponse.data?.url;
    const key = uploadUrlResponse.data?.key;

    if (!uploadUrl || !key) {
      throw new Error("Upload URL foto tidak valid dari backend.");
    }

    const uploadResponse = await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": getMimeFromDataUrl(imageSrc),
      },
      body: fotoBlob,
    });

    if (!uploadResponse.ok) {
      throw new Error("Upload foto gagal.");
    }

    return key;
  };

  const validateForm = () => {
    const missing = [];

    if (!String(nomorTandaTerima || "").trim()) {
      missing.push("Nomor Tanda Terima");
    }

    if (!String(pengirim || "").trim()) {
      missing.push("Pengirim");
    }

    if (!imageSrc) {
      missing.push("Foto Pengirim");
    }

    if (!String(selectedRooms || "").trim()) {
      missing.push("Tipe Dokumen");
    }

    if (!String(selectedStorage || "").trim()) {
      missing.push("Disimpan");
    }

    if (!String(lokasi || "").trim()) {
      missing.push("Lokasi Penerimaan");
    }

    if (!companyName) {
      missing.push("Nama Perusahaan");
    }

    /**
     * Do not force clientPhone here because the fixed backend may resolve
     * the latest phone from DB using kontrakId / klienId.
     * The backend must be the final validator.
     */
    if (!clientName && !mainContract?.KlienID && !useData?.klien?._id) {
      missing.push("Nama Klien / KlienID");
    }

    if (missing.length > 0) {
      setError(`Ada data kosong: ${missing.join(", ")}`);
      return false;
    }

    return true;
  };

  const simpanSurat = async () => {
    if (saving) return;

    setError("");
    setSuccess("");

    if (!validateForm()) return;

    setSaving(true);

    try {
      setProgressText("Upload foto...");

      const fotoBlob = dataURLtoBlob(imageSrc);

      if (!fotoBlob) {
        throw new Error("Foto tidak valid. Ambil ulang foto.");
      }

      const fotoKey = await uploadPhotoAndGetKey(fotoBlob);

      const dataSurat = {
        fotoKey,
        nomorTandaTerima: String(nomorTandaTerima || "").trim(),
        pengirim: String(pengirim || "").trim(),
        TipeDok: selectedRooms,
        storage: selectedStorage,
        tanggalKejadian,
        notes,
        lokasi,
      };

      setProgressText("Mengirim WhatsApp via Cekat...");

      const payload = {
        tipe: "Surat",
        dataSurat,
        tanggalKejadian,

        /**
         * Set Yes because this submit is intended to notify the client.
         * Backend should still decide final notifyStatus after Cekat response.
         */
        statNotify: "Yes",

        /**
         * Important:
         * Send IDs + fallback full object.
         * Backend should fetch fresh DB data and not trust stale frontend data.
         */
        useData: buildUseDataPayload(useData),

        searchThis,
        lokasi,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/saveSurat`,
        payload
      );

      setProgressText("");
      setSuccess(
        response.data?.message ||
          "Surat tersimpan dan WhatsApp berhasil dikirim."
      );

      if (typeof onSaved === "function") {
        onSaved(response.data);
      }

      setTimeout(() => {
        closeNewMail();
      }, 800);
    } catch (error) {
      console.error(error);

      setProgressText("");
      setError(getErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Grid sx={{ p: 2 }}>
      <Typography variant="h5">
        <b>New Paket/Surat</b>
      </Typography>

      <Alert severity={useData?.recipientReady === false ? "warning" : "info"} sx={{ mt: 2 }}>
        <b>Tujuan Notifikasi:</b>
        <br />
        Perusahaan: {companyName || "-"}
        <br />
        Klien: {clientName || "-"}
        <br />
        WhatsApp: {clientPhone || "Akan dicek ulang oleh backend"}
        <br />
        Kontrak: {mainContract?.kontrakNum || mainContract?._id || "-"}
      </Alert>

      {useData?.missingReason && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          {useData.missingReason}
        </Alert>
      )}

      <Grid container>
        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Nomor Tanda Terima*
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <TextField
            disabled={saving}
            onChange={(event) => setNomorTandaTerima(event.target.value)}
            value={nomorTandaTerima}
            placeholder="Nomor Dokumen Fisik"
            fullWidth
          />
        </Grid>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Pengirim*
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <TextField
            disabled={saving}
            onChange={(event) => setPengirim(event.target.value)}
            value={pengirim}
            placeholder="Bukan Gojek, tapi dari?"
            fullWidth
          />
        </Grid>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Foto Pengirim*
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <Button
            disabled={saving}
            onClick={handleOpenCamera}
            variant="contained"
          >
            Ambil Foto
          </Button>

          {imageSrc && (
            <Box sx={{ mt: 1 }}>
              <img
                src={imageSrc}
                alt="Captured"
                style={{ maxWidth: "100%", height: "auto" }}
              />

              <Box sx={{ mt: 1 }}>
                <Button
                  disabled={saving}
                  color="warning"
                  variant="outlined"
                  onClick={() => setImageSrc(null)}
                >
                  Hapus Foto
                </Button>
              </Box>
            </Box>
          )}
        </Grid>

        <Dialog open={openCamera} onClose={handleCloseCamera} maxWidth="md">
          <DialogTitle>Take a Photo</DialogTitle>

          <DialogContent>
            {capturing ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{
                  facingMode: "user",
                }}
              />
            ) : (
              <img src={imageSrc} alt="Captured" style={{ maxWidth: "100%" }} />
            )}
          </DialogContent>

          <DialogActions>
            {capturing ? (
              <>
                <Button onClick={handleCapture} color="primary">
                  Capture
                </Button>

                <Button onClick={handleCloseCamera} color="secondary">
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <Button onClick={handleUsePhoto} color="primary">
                  Use Photo
                </Button>

                <Button onClick={handleRetake} color="secondary">
                  Retake
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Lokasi Penerimaan*
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <Select
            disabled={saving}
            value={lokasi || ""}
            whiteSpace="normal"
            onChange={(event) => setLokasi(event.target.value)}
            fullWidth
            displayEmpty
          >
            <MenuItem value="">
              <em>Pilih Lokasi</em>
            </MenuItem>

            {categorias.map((categoria) => (
              <MenuItem key={categoria} multiline value={categoria}>
                {categoria}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12}>
          <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
        </Grid>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Tanggal Penerimaan
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item sm={6} sx={{ mt: 3 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
              disabled={saving}
              views={["year", "month", "day"]}
              inputFormat="dd/MM/yyyy"
              value={tanggalKejadian}
              onChange={(newValue) => setTanggalKejadian(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment position="end">
                        <CalendarMonthIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Tipe Dokumen
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <Autocomplete
            disabled={saving}
            sx={{ width: "100%" }}
            options={names}
            freeSolo
            getOptionLabel={(option) => option || ""}
            value={selectedRooms}
            onChange={(event, newValue) => {
              setSelectedRooms(newValue || "");
            }}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === "input") {
                setSelectedRooms(newInputValue || "");
              }
            }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="" />
            )}
            renderOption={(props, option, { selected }) => (
              <MenuItem
                {...props}
                key={option}
                value={option}
                sx={{ justifyContent: "space-between" }}
              >
                {option}
                {selected ? <CheckIcon color="info" /> : null}
              </MenuItem>
            )}
          />
        </Grid>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Disimpan
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <Autocomplete
            disabled={saving}
            sx={{ width: "100%" }}
            options={storage}
            freeSolo
            getOptionLabel={(option) => option || ""}
            value={selectedStorage}
            onChange={(event, newValue) => {
              setSelectedStorage(newValue || "");
            }}
            onInputChange={(event, newInputValue, reason) => {
              if (reason === "input") {
                setSelectedStorage(newInputValue || "");
              }
            }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="" />
            )}
            renderOption={(props, option, { selected }) => (
              <MenuItem
                {...props}
                key={option}
                value={option}
                sx={{ justifyContent: "space-between" }}
              >
                {option}
                {selected ? <CheckIcon color="info" /> : null}
              </MenuItem>
            )}
          />
        </Grid>

        <Grid item xs={5.5} sx={{ mt: 3 }}>
          Notes
        </Grid>

        <Grid item xs={0.5} sx={{ mt: 3 }}>
          :
        </Grid>

        <Grid item xs={6} sx={{ mt: 3 }}>
          <TextareaAutosize
            disabled={saving}
            style={{
              minHeight: "150px",
              width: "100%",
              fontSize: "16px",
              fontFamily: "Open Sans, sans-serif",
            }}
            value={notes}
            onChange={(event) => setNotes(event.target.value)}
          />
        </Grid>
      </Grid>

      {progressText && (
        <Alert severity="info" sx={{ mb: 2, mt: 3 }}>
          <Box display="flex" alignItems="center">
            <CircularProgress size={18} sx={{ mr: 1 }} />
            {progressText}
          </Box>
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2, mt: 3 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2, mt: 3 }}>
          {success}
        </Alert>
      )}

      <Grid container>
        <Box display="flex" justifyContent="flex-end" width="100%" gap={1}>
          <Button
            sx={{ mt: 3 }}
            variant="outlined"
            color="inherit"
            onClick={closeNewMail}
            disabled={saving}
          >
            Batal
          </Button>

          <Button
            sx={{ mt: 3 }}
            variant="contained"
            onClick={simpanSurat}
            disabled={saving}
          >
            {saving ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Menunggu Cekat...
              </>
            ) : (
              "Simpan & Kirim WhatsApp"
            )}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}